module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.showSidebar ? 'Calc show' : 'Calc'
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Вернутся назад")]), _vm._v(" "), _c('div', {
    staticClass: "overflowContainer"
  }, [_c('div', {
    staticClass: "overflow"
  }, _vm._l((_vm.data.fields), function(itemForm) {
    return _c('div', {
      staticClass: "serviceContainer"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(itemForm.title))]), _vm._v(" "), _vm._l((itemForm.items), function(element) {
      return _c('div', {
        staticClass: "item"
      }, [(element.type === 'radio') ? [_c('label', [_c('input', {
        attrs: {
          "type": element.type,
          "name": element.radioname,
          "disabled": element.locked
        },
        domProps: {
          "value": element.name
        },
        on: {
          "change": function($event) {
            return _vm.onChangeRadio($event, element)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(element.text))]), _vm._v(" "), (element.label) ? _c('span', {
        staticClass: "recommend"
      }, [_vm._v(_vm._s(element.label))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "rside"
      }, [(element.cost) ? _c('div', {
        staticClass: "rsideContainer"
      }, [_c('p', {
        staticClass: "cost",
        domProps: {
          "innerHTML": _vm._s(element.cost)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "infoContainerWr"
      }, [(element.info) ? _c('div', {
        staticClass: "infoContainer"
      }, [_c('span', {
        staticClass: "info",
        on: {
          "click": function($event) {
            return _vm.show($event)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "infoWr"
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(element.info)
        }
      })])]) : _vm._e()])]) : _vm._e()])] : (element.type === 'checkbox') ? [_c('label', [_c('input', {
        attrs: {
          "type": element.type,
          "name": element.name,
          "disabled": element.locked
        },
        domProps: {
          "value": element.name
        },
        on: {
          "change": function($event) {
            return _vm.onChange($event, element)
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(element.text))]), _vm._v(" "), (element.label) ? _c('span', {
        staticClass: "recommend"
      }, [_vm._v(_vm._s(element.label))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "rside"
      }, [(element.cost) ? _c('div', {
        staticClass: "rsideContainer"
      }, [_c('p', {
        staticClass: "cost",
        domProps: {
          "innerHTML": _vm._s(element.cost)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "infoContainerWr"
      }, [(element.info) ? _c('div', {
        staticClass: "infoContainer"
      }, [_c('span', {
        staticClass: "info",
        on: {
          "click": function($event) {
            return _vm.show($event)
          }
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "infoWr"
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(element.info)
        }
      })])]) : _vm._e()])]) : _vm._e()])] : _vm._e()], 2)
    })], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "buttonWr"
  }, [_c('div', {
    staticClass: "button buy",
    domProps: {
      "innerHTML": _vm._s(((_vm.data.button) + "&nbsp;" + _vm.buttonText))
    },
    on: {
      "click": _vm.submit
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button demo",
    attrs: {
      "target": "_blank",
      "href": _vm.data.button2Href
    }
  }, [_vm._v(_vm._s(_vm.data.button2))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe63d044"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/form-product-sidebar.vue
// module id = 407
// module chunks = 14